import { motion } from "framer-motion";

const testimonials = [
  {
    quote:
      "Preksha showed results in the first few ads — the clinic was filled with new walk-ins and much more.",
    name: "Dr. Gujar",
    role: "Ayurved Specialist",
    initial: "G",
  },
  {
    quote:
      "Preksha helped me be super comfortable in front of the camera. Her being a non-medico never reflects in the content — it's classic. We get visitors from all over the state and outstation too. Clearly, marketing wins.",
    name: "Dr. Pramod Satpute",
    role: "Diabetic Foot Specialist",
    initial: "P",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="bg-white py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="mb-16 max-w-2xl">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-blue-deep">/ Patient voices</span>
          <h2 className="mt-4 font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-obsidian md:text-5xl">
            Doctors who stopped being a secret.
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-slate-200 bg-slate-200 md:grid-cols-2">
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`testimonial-${i}`}
              className="flex flex-col justify-between gap-8 bg-white p-8 md:p-10"
            >
              <blockquote className="font-display text-2xl font-medium leading-snug text-obsidian md:text-3xl">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="flex items-center gap-4">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-blue-light font-display text-2xl font-extrabold text-blue-deep ring-2 ring-lab-light">
                  {t.initial}
                </span>
                <div>
                  <p className="font-display font-bold text-obsidian">{t.name}</p>
                  <p className="font-mono text-xs uppercase tracking-[0.1em] text-slate-500">{t.role}</p>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
